import { TripsState } from "../../../store";

export const getPassengersState = (state: TripsState) => state.passengers;

export const getPassengers = (state: TripsState) =>
  getPassengersState(state).passengers;

export const getPassengersCallState = (state: TripsState) =>
  getPassengersState(state).passengersCallState;
